<div class="cv-rule-set-component" *ngIf="isOpen">
	<div class="cv-rule-set-box">
		<label class="cv-rule-set-box__title">Change rule sets for current order</label>
		<div class="cv-rule-set-box-optContent scrollable scrollable-component">
			<div class="cv-rule-set-box-options" *ngFor="let item of ruleSet">
				<label>
					<input
						class="form-check-input"
						type="checkbox"
						id="{{ item.id }}"
						[checked]="isCheked(item.id)"
						(change)="onCheckChanges($event, item.id)"
					/>
					{{ item.name }}
				</label>
			</div>
			<div *ngIf="!ruleSet.length || noRuleSetAvailable" class="empty-rules-message">
				<div>
					<label *ngIf="!ruleSet.length && !noRuleSetAvailable" class="cv-rule-set-box__loading">Loading...</label>
					<label *ngIf="noRuleSetAvailable" class="no-results">No rules sets available</label>
				</div>
			</div>
		</div>

		<div class="cv-rule-set-box-contentbtn action-button">

			<p-button
				class="p-button-outlined p-button-danger"
				(onClick)="close()">
				<i class="pi pi-times"></i>
				Cancel
			</p-button>

			<p-button
				*ngIf="!noRuleSetAvailable"
				[disabled]="!executedRule.length"
				(onClick)="reRunRules()">
				<i class="pi pi-check" ></i>
				update and re-run
			</p-button>
		</div>
	</div>
</div>
